<template>
  <div v-if="isSignedIn" class="xp-container">
    <div class="stat-stack" :class="{'streak-today' : hasStreakToday}">
      <span class="streak"><span class="count">{{ getStreak | stat }}</span></span>
      <svg class="icon-streak" width="448" height="544" viewBox="0 0 448 544" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M160.5 5.60002C169.8 -2.19998 183.6 -1.79998 192.4 6.50002C204.6 18.1 215.7 30.9 226.3 43.9C239.8 60.4 256 82.2 271.6 108.1C276.8 101.3 281.6 95.3 285.8 90.2C286.9 88.9 288 87.5 289.2 86.1C297 76.3 306.9 64 320 64C333.4 64 342.8 75.9 350.8 86.1C352.1 87.8 353.4 89.4 354.7 90.9C365 103.3 378.7 121.2 392.4 143.3C419.6 187.2 448 249.7 448 319.9C448 443.6 347.7 543.9 224 543.9C100.3 543.9 0 443.7 0 320C0 228.9 41.1 150 80.5 95C100.4 67.3 120.2 45.1 135.1 29.9C143.3 21.5 151.6 13.2 160.6 5.70003L160.5 5.60002ZM289.8 166.3C285.2 173.6 277 177.9 268.4 177.5C259.8 177.1 252 172.1 248.1 164.3C229.1 126.7 206.8 95.8 189.2 74.2C184 67.8 179.2 62.2 175 57.6C173.2 59.3 171.4 61.2 169.4 63.2C155.8 77.2 137.6 97.5 119.5 122.8C82.9 173.8 48 242.9 48 319.8C48 417 126.8 495.8 224 495.8C321.2 495.8 400 417 400 319.8C400 262.1 376.4 208.5 351.6 168.4C340.3 150.1 328.9 135 320 124C311.5 134.5 300.7 148.8 289.8 166.1V166.3ZM225.7 448C162.5 448 112 407.4 112 338.8C112 291.3 145.2 252.3 163.5 234.5C169.8 228.4 179.6 229.5 185 236.4C201.2 256.9 233 297.3 250.3 319.4C256.5 327.3 268.4 327.6 275 319.9L300.2 290.6C306.7 283 318.2 283.7 322.7 292.6C348 338.8 336.7 397.6 294.6 427C273.5 441 251.1 448 225.8 448H225.7Z" />
      </svg>
    </div>

    <div class="stat-stack xp" :class="{'focus' : isFocused }">
      <span class="xp" :class="{'focus' : isFocused}"><span class="count">{{ getXPToday | stat }}</span></span>
      <svg class="icon-xp" id="sparkles" width="559" height="566" viewBox="0 0 559 566" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M206.5 85.3C203.9 79.6 198.2 76 192 76C185.8 76 180.1 79.6 177.5 85.3L124.4 200.3L9.4 253.4C3.6 256.1 0 261.8 0 268C0 274.2 3.6 279.9 9.3 282.5L124.3 335.6L177.4 450.6C180 456.3 185.7 459.9 191.9 459.9C198.1 459.9 203.8 456.3 206.4 450.6L259.5 335.6L374.5 282.5C380.2 279.9 383.8 274.2 383.8 268C383.8 261.8 380.2 256.1 374.5 253.5L259.5 200.4L206.4 85.4L206.5 85.3Z" fill="black"/>
        <path d="M347.5 459.2L404 438L425.2 381.5C426.9 377 431.2 374 436 374C440.8 374 445.1 377 446.8 381.5L468 438L524.5 459.2C529 460.9 532 465.2 532 470C532 474.8 529 479.1 524.5 480.8L468 502L446.8 558.5C445.1 563 440.8 566 436 566C431.2 566 426.9 563 425.2 558.5L404 502L347.5 480.8C343 479.1 340 474.8 340 470C340 465.2 343 460.9 347.5 459.2Z" fill="black"/>
        <path d="M367 96C367 91.2 370 86.9 374.5 85.2L431 64L452.2 7.5C453.9 3 458.2 0 463 0C467.8 0 472.1 3 473.8 7.5L495 64L551.5 85.2C556 86.9 559 91.2 559 96C559 100.8 556 105.1 551.5 106.8L495 128L473.8 184.5C472.1 189 467.8 192 463 192C458.2 192 453.9 189 452.2 184.5L431 128L374.5 106.8C370 105.1 367 100.8 367 96Z" fill="black"/>
      </svg>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        isFocused: false
      }
    },

    mounted () {
      this.EventBus.$on('xp:sparkle', () => {
        this.animateXP();
      })
    },

    computed: {
      isAlpha() {
        return this.$store.getters.isAlpha;
      },

      isSignedIn() {
        return this.$store.getters.isLoggedIn; 
      },

      getXPToday() {
        return this.$store.getters.getXPToday;
      },

      getXPAvg() {
        return this.$store.getters.getXPAvg;
      },

      getStreak() {
        return this.$userEngine.getStreak;
      },

      hasStreakToday() {
        return this.$userEngine.hasStreakToday;
      },

      getStreakBest() {
        return 0;
      },
    },

    methods: {
      animateXP() {
        this.isFocused = true;
        const paths = document.querySelectorAll("#sparkles path");

        paths.forEach((path, i) => {
          setTimeout(() => {
            path.classList.add("focus");
            setTimeout(() => path.classList.remove("focus"), 300);
          }, i * 400);
        });
        
        setTimeout(() => {
          this.isFocused = false;
        }, 1200)
      }
    },
  }
</script>

<style lang="scss" scoped>
  @import 'src/assets/scss/v5.scss';

  .xp-container {
    display: flex;
    align-items: center;
    gap: 1rem;
    align-self: center;
    transition: all 0.2s ease-in-out;

    .stat-stack {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 0.35rem;
      text-align: right;
      font-size: 1.1rem;

      // &.xp {
      //   &.focus {
      //     background: rgba($purple-tone-3, 0.3);

      //     .darkmode & {
      //       background: rgba($purple-tone-2, 0.3);
      //     }
      //   }
      // }

      .xp {
        transition: all 0.2s ease-in-out;
        font-weight: bold;
        color: $purple-tone-3;
        
        .darkmode & {
          color: $purple-tone-2;
        }

        &.focus {
          color: $purple-tone-2;
          transform: scale(1.05);

          .darkmode & {
            color: $purple-tone-1;
          }
        }
      }

      .streak {
        font-weight: bold;
        color: $orange-tone-3;
      }

      .feint {
        opacity: .5;
      }
    }

    svg {
      width: 1rem;
      height: $header-height;

      &.icon-xp {
        path {
          transition: all 0.2s ease-in-out;
          fill: $purple-tone-3;

          .darkmode & {
            fill: $purple-tone-2;
          }
        }

        .focus {
          fill: $purple-tone-2;

          .darkmode & {
            fill: $neutral-600;
          }
        }
      }

      &.icon-streak {
        path {
          fill: $orange-tone-3;
        }
      }
    }
  }

  .streak-today {
    .streak {
      color: $green-tone-3 !important;
    }

    .icon-streak path {
      fill: $green-tone-3 !important;
    }
  }
</style>